import {ChangeDetectionStrategy, Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ContentService} from "../../_services/content.service";
import {SnackbarService} from "../../_services/snackbar.service";
import {ConfirmDialogComponent} from "../confirm-dialog/confirm-dialog.component";
import {ConfirmationDialogData} from "../../_types/shared";
import {TimelineListItem} from "../../_types/memorybox";
import {AuthService} from "../../_services/auth.service";

@Component({
    selector: 'app-duplicate-form',
    templateUrl: './duplicate-form.component.html',
    styleUrl: './duplicate-form.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DuplicateFormComponent {
    @ViewChild('userInput') userInput: any;
    selectedTimelines: TimelineListItem[] = [];
    memoryId: number | undefined;
    childId: number | undefined;
    loading: boolean = false;

    constructor(@Inject(MAT_DIALOG_DATA) private data: { id: number, childId?: number },
                protected dialogRef: MatDialogRef<DuplicateFormComponent>,
                private snackbarService: SnackbarService,
                private contentService: ContentService,
                private authService: AuthService,
                public dialog: MatDialog) {

        if (data?.id) {
            this.memoryId = data.id;
        }
        if (data?.childId) {
            this.childId = data?.childId;
        }
    }

    selectTimelines(timelines: TimelineListItem[]): void {
        this.selectedTimelines = timelines;
    }

    duplicate(): void {
        this.loading = true;
        if (this.memoryId) {
            let users: string[] = []
            for (let user of this.selectedTimelines) {
                users.push(this.authService.getDisplayName(user));
            }
            const dialogRef: MatDialogRef<ConfirmDialogComponent> = this.dialog.open<ConfirmDialogComponent, ConfirmationDialogData>(ConfirmDialogComponent, {
                panelClass: 'mediumWindow',
                data: {
                    showSubmitBtn: true,
                    showCancelBtn: true,
                    message: 'Are you sure you want to duplicate this album for the following users: ' + users.join(', ') + '?',
                    title: 'Duplicate Album',
                    showHeader: true
                }
            });
            dialogRef.afterClosed().subscribe((resp): void => {
                if (resp && this.memoryId) {
                    for (let index: number = 0; index < this.selectedTimelines.length; index++) {
                        this.contentService.duplicateMemory(this.memoryId, this.selectedTimelines[index].id).subscribe({
                            next: r => {
                                if (index == (this.selectedTimelines.length - 1)) {
                                    this.snackbarService.openSnackBar('Media Successfully Duplicated', 'success')
                                    this.dialogRef.close();
                                    this.loading = false;
                                }
                            }, error: error => {
                                this.snackbarService.openSnackBar(error, 'error')
                                console.error(error)
                                if (index == (this.selectedTimelines.length - 1)) {
                                    this.loading = false;
                                }
                            }
                        });
                    }
                } else {
                    this.loading = false;
                }
            });
        }
    }
}
